import { useLocation, useNavigate } from 'react-router';
import Voteimage from 'assets/img/votes.png';
import { useEffect, useState } from 'react';
import { getEvaluatedRealizations } from 'services/evaluation.service';
import { useAuth } from 'context/AuthContext';
import Spinner from 'components/ui/Spinner';
import { RealizationEvItem } from 'types/realization';
import CardEvaluated from 'components/ui/CardEvaluated';

const Evaluation = () => {
    const { user, updateNotifications } = useAuth();
    const location = useLocation();
    const [isLoading, setIsLoading] = useState(true);
    const navigate = useNavigate();
    const [listEvaluated, setListEvaluated] = useState<RealizationEvItem[]>([]);
    const [isBossEvaluation, setIsBossEvaluation] = useState(false);
    useEffect(() => {
        const fetchEvaluated = async () => {
            if (!user || !user._id) return;

            setIsLoading(true);
            try {
                const data = await getEvaluatedRealizations(user);
                console.log(data);
                if (data) {
                    setIsBossEvaluation(data.step === 2 ? true : false);
                    setListEvaluated(data.realizations);
                } else {
                    navigate(user.detail.isBoss || user.detail.acessor.vp ? '/evaluation-president/vote' : '/evaluation/vote');
                }
            } catch (e) {
                console.error('Erro ao buscar avaliações:', e);
            } finally {
                updateNotifications();
                setIsLoading(false);
            }
        };

        fetchEvaluated();
    }, [user, navigate]);

    const Title = () => {
        const [currentTitle, setCurrentTitle] = useState('Esses foram seus votos!');

        useEffect(() => {
            if (user?.detail.acessor && user?.detail.acessor.vp) {
                setCurrentTitle(`Esses foram os votos do vice presidente da ${user?.detail.acessor.vp.diretoria}`);
            }
        }, [user?.detail]);

        return <h2 className="mb-3 text-[32px] font-bold text-black-bb font-title">{currentTitle}</h2>;
    };

    return isLoading ? (
        <div className="flex items-start justify-center w-full h-screen">
            <div className="flex flex-col">
                <Spinner />
                <span className="text-center text-blue-bb">Carregando...</span>
            </div>
        </div>
    ) : (
        <div className="flex flex-col items-start justify-between mx-4 gap-9 md:flex-row md:mx-0">
            <div className="flex-1">
                <div className="relative top-0 md:top-8">
                    <Title />
                </div>

                <div className="mt-10">
                    {listEvaluated?.map((item: RealizationEvItem, index: number) => (
                        <div className="mb-5">
                            <CardEvaluated data={item} key={index} isBossEvaluator={isBossEvaluation} />
                        </div>
                    ))}
                </div>
            </div>
            <div className="flex-1">
                <img width={'100%'} src={Voteimage} alt="Votos" />
            </div>
        </div>
    );
};

export default Evaluation;
